import { SimulationSearchFilters } from '../models/simulation.model';

export const INITIAL_SIMULATION_FILTER_STATE: SimulationSearchFilters = {
  types: [
    { checked: false, id: 'subsampleKabs', name: 'SubsampleKabs' },
    { checked: false, id: 'subsampleFF', name: 'SubsampleFF' },
    { checked: false, id: 'subsamplePtsd', name: 'SubsamplePtsd' },
    { checked: false, id: 'subsamplePC', name: 'SubsamplePC' },
    { checked: false, id: 'subsampleKr', name: 'SubsampleKr' },
    { checked: false, id: 'subsampleCubeTrendKabs', name: 'SubsampleCubeTrendKabs' },
    { checked: false, id: 'subsampleCubeTrendFF', name: 'SubsampleCubeTrendFF' },
    { checked: false, id: 'subsampleN', name: 'SubsampleN' },
    { checked: false, id: 'upscalingKabs', name: 'UpscalingKabs' },
    { checked: false, id: 'upscalingFF', name: 'UpscalingFF' },
    { checked: false, id: 'upscalingPC', name: 'UpscalingPC' },
    { checked: false, id: 'upscalingKr', name: 'UpscalingKr' },
    { checked: false, id: 'upscalingN', name: 'UpscalingN' },
  ],
  runStatus: [
    { checked: false, id: 'success', name: 'Success' },
    { checked: false, id: 'failure', name: 'Failure' },
    { checked: false, id: 'waiting', name: 'Waiting' },
    { checked: false, id: 'initializing', name: 'Initializing' },
    { checked: false, id: 'processing', name: 'Processing' },
    { checked: false, id: 'canceled', name: 'Canceled' },
  ],
  directions: {
    x: true,
    y: true,
    z: true,
  },
  startDate: null,
  endDate: null,
  searchString: '',
  filterType: 'User',
  page: 1,
  pageSize: 10,
};
